import React from 'react';
import { PhotoSwipeOptions } from 'photoswipe';
import { Gallery, Item } from 'react-photoswipe-gallery';

import 'photoswipe/dist/photoswipe.css';

import { FragmentMediaImageFragment } from '@/utils/drupal-api/__generated__/graphql';
import { ImageSrcSetSize } from '@/utils/image';
import clsx from 'clsx';

import MediaUnionComponent from '@/components/cms/media_union';

type PropType = {
  data: FragmentMediaImageFragment[];
  imageAspectThumb?: number;
  imageSizesThumb?: ImageSrcSetSize[];
  slideClassName?: string;
  sectionClassName?: string;
  figureClassName?: string;
  galleryClassName?: string;
  itemClassName?: string;
  startIndex?: number;
};
interface ExtendedPhotoSwipeOptions extends PhotoSwipeOptions {
  click?: 'close' | 'zoom' | 'zoom-or-close' | false;
  tapToClose?: boolean;
  doubleTapZoom?: number;
  verticalDragRange?: number;
  allowMouseDrag?: boolean;
}

const galleryOptions: Partial<ExtendedPhotoSwipeOptions> = {
  showHideAnimationType: 'fade',
  padding: { top: 20, bottom: 20, left: 60, right: 60 },
  closeOnVerticalDrag: true,
  bgOpacity: 0.8,
  allowPanToNext: true,

  // Enhanced mobile-specific options
  click: 'close',
  tapToClose: true,
  doubleTapZoom: 2,

  // Important for mobile behavior
  imageClickAction: 'zoom-or-close',
  bgClickAction: 'close',
  tapAction: 'close',

  // Additional gesture options
  pinchToClose: true,
  verticalDragRange: 0.6,
  allowMouseDrag: true,
  mouseMovePan: true,
  spacing: 0.1,
  loop: false,
};

const CmsGallery: React.FC<PropType> = (props) => {
  const {
    data,
    imageAspectThumb,
    imageSizesThumb,
    slideClassName,
    sectionClassName,
    figureClassName,
    galleryClassName,
    itemClassName,
    startIndex = 0,
  } = props;

  const options: Partial<ExtendedPhotoSwipeOptions> = {
    ...galleryOptions,
    index: startIndex,
  };

  return (
    <Gallery options={options} withCaption>
      <div className={galleryClassName}>
        {data.map((image, index) => (
          <Item
            key={index}
            original={image.mediaImage.url || ''}
            width={image.mediaImage.width || 0}
            height={image.mediaImage.height || 0}
            alt={image.mediaImage.alt || ''}
            caption={image.caption || ''}
          >
            {({ ref, open }) => (
              <a
                ref={ref}
                onClick={open}
                className={clsx(
                  'cursor-pointer transition-opacity hover:opacity-85',
                  itemClassName
                )}
              >
                <MediaUnionComponent
                  data={image}
                  imageAspect={imageAspectThumb}
                  imageSizes={imageSizesThumb}
                  className={sectionClassName}
                  figureClassName={figureClassName}
                  imageClassName={slideClassName}
                />
              </a>
            )}
          </Item>
        ))}
      </div>
    </Gallery>
  );
};

export default CmsGallery;
